import TableSegmentDemandReport from './TableSegmentDemandReport';

export default TableSegmentDemandReport;
export { TableSegmentDemandReport };
